<template>
	<div class="goods">
		<!-- <v-head :title="title"></v-head>
		<div class="content">
		
		<div class="contBox">
			<div class="fontBocs">
				<van-icon name="balance-pay" />
                <h4>等待支付费用</h4>
			</div>
			
			<div>订单号：{{this.state}}</div>
			<div>订单金额：{{this.order.amount}}</div>
		</div>
	</div>
	<div class="embut">
      <el-button type="primary" @click="submit" class="buttonBox">立即支付</el-button>
    </div> -->
	</div>
</template>

<script type="text/javascript">
	import vHead from "../../components/Subhead.vue";

	import { mapState } from "vuex";
	import { Uploader, Toast, Icon } from "vant";
	import {
		getOpenid,
		getOrderDetails,
		getMeetingWXCode,
		getUser
	} from "@/api/dictionary";
	export default {
		data() {
			return {
				fileList: [],
				commentImg: [],
				title: "线上支付",
				code: null,
				state: null,
				WxUser: {
					openid: null
				},
				order: {
					amount: null
				},
			}
		},
		components: {
			vHead,
			[Uploader.name]: Uploader,
			[Toast.name]: Toast,
			[Icon.name]: Icon,

		},
		computed: {
			orderId() {
				return this.$route.query && this.$route.query.orderId;
			},
			...mapState(["userInfo"])
		},
		methods: {
			getQueryString(name) {
				var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
				var r = window.location.search.substr(1).match(reg);
				if (r != null) return r[2]; return '';

			},
			getO(code) {
				getOpenid({ code: code })
					.then(res => {
						if (res.success) {
							this.WxUser = res.result;
							if (!this.WxUser.openid) {
								this.$tips.error("付款失败");
								return;
							}
							this.orderDetails();
						}
					})
				// getOrderDetails({orderNo:this.state})
				// 	.then(res=>{
				// 		this.order = res.result;
				// 	})
			},
			getWxBridge(res) {
				this.res = res;
				if (typeof WeixinJSBridge == "undefined") {
					if (document.addEventListener) {
						document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
					} else if (document.attachEvent) {
						document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
						document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
					}
				} else {
					//onBridgeReady(res);
				}
			},
			onBridgeReady(data) {
				var that = this
				WeixinJSBridge.invoke(
					'getBrandWCPayRequest', {
					"appId": data.appid,
					"timeStamp": data.timeStamp,
					"nonceStr": data.nonceStr,
					"package": "prepay_id=" + data.prepayId,
					"signType": "MD5",
					"paySign": data.sign
				},
					function (res) {
						//that.f=  JSON.stringify(res);
						if (res.err_msg == "get_brand_wcpay_request:ok") {
							// 使用以上方式判断前端返回,微信团队郑重提示：
							//res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。

							//that.ok = JSON.stringify(res);
							that.$router.push({ name: "signuppayResult", query: { orderNo: that.state } });
						} else if (res.err_msg == "get_brand_wcpay_request:cancel") {
							// that.cancel = JSON.stringify(res);

						} else {
							//that.other= JSON.stringify(res);
						}
					});
			},
			//调用接口下单
			orderDetails() {
				let params = {
					orderNo: this.state,
					// totalFee: this.order.amount,
					openid: this.WxUser.openid,
					tradeType: "JSAPI"
				};
				getMeetingWXCode(params)
					.then(res => {
						this.getWxBridge(res);
						this.onBridgeReady(res);
					})
			},
			submit() {
				if (!this.WxUser.openid) {
					this.$tips.error("付款失败");
					return;
				}
				this.orderDetails();

			},

		},
		mounted() {
			var url = window.location.href; //获取url中"?"符后的字串 ('?modFlag=business&role=1')
			// var url = "http://localhost:8080/#/onlinePaymentMeeting?memberId=c940d6bb-0be9-4c36-afac-35078866e643&access_token=23223";
			let begin = url.indexOf("?");
			let a = url.substring(begin, url.length);
			var theRequest = new Object();
			if (a.indexOf("?") != -1) {
				var str = a.substr(1); //substr()方法返回从参数值开始到结束的字符串；
				var strs = str.split("&");
				for (var i = 0; i < strs.length; i++) {
					theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
				}
				this.memberIdUrl = theRequest.memberId;
				console.log(this.memberIdUrl)
				sessionStorage.setItem("memberId", this.memberIdUrl)
				this.access_token = theRequest.access_token;
				console.log(this.access_token)
				sessionStorage.setItem("access_token", this.access_token)
				if (this.access_token) {
					getUser().then((res) => {
						if (res.success) {
							window.localStorage.setItem("userInfo", JSON.stringify(res.result));
						}
					});
				}
			}
			this.code = this.getQueryString("code");
			this.state = this.getQueryString("state");
			this.getO(this.code);
			this.getWxBridge();
		}
	};
</script>

<style type="text/css" lang="less" scoped>
	.content {
		background: #378be1;
		position: relative;
		height: 3rem;
	}

	.goods {
		position: fixed;
		height: 100%;
		width: 100%;
		background: #efefef;
	}

	/deep/.van-nav-bar .van-icon {
		color: #fff;
	}

	.contBox div {
		font-size: 16px;
		color: #333;
		margin-top: 20px;
		font-family: Arial, Helvetica, sans-serif;
	}

	.contBox {
		background: #fff;
		padding: 5% 20px 10% 20px;
		width: 81%;
		position: absolute;
		left: 4%;
		border-radius: 8px;
		top: 30%;

		h4 {
			color: #378be1;
			font-size: 16px;
			font-weight: bold;
			margin-bottom: 20px;
		}
	}

	.embut {
		display: inline-block;
		width: 100%;
		text-align: center;
		margin-top: 40%;
	}

	.buttonBox {
		background: #fda005;
		border-radius: 5px;
		width: 90%;
		color: #fff;
		margin: 0 18px;
		text-align: center;
		font-size: 16px;
		height: 46px;
		line-height: 46px;
		display: inline-block;
		margin-top: 50px;
	}

	.fontBocs {
		color: #378be1 !important;
		text-align: center;
		margin-bottom: 40px;
	}

	.fontBocs i {
		font-size: 40px !important;
		margin-bottom: 20px;
	}
</style>